import { Outlet } from 'react-router-dom';
import { ClientPages, ClientWrapperPages, Params } from '../utils/RouteEnums';
import React from 'react';

// Lazy-loaded components
const ProductApprovalWrapper = React.lazy(() => import('../components/client/userMenu/product/ProductApprovalWrapper'));
const ServiceWrapper = React.lazy(() => import('../components/client/userMenu/service/ServiceWrapper'));
const FormulationWrapper = React.lazy(() => import('../components/client/userMenu/product/FormulationWrapper'));
const ProductDetails = React.lazy(() => import('../components/client/userMenu/product/details/ProductDetails'));
const ProductWrapper = React.lazy(() => import('../components/client/userMenu/product/ProductWrapper'));
const DashboardMyCompanyWrapper = React.lazy(
    () => import('../components/client/userMenu/dashboard/myCompany/DashboardMyCompanyWrapper')
);
const OilTestEnginesWrapper = React.lazy(
    () => import('../components/client/userMenu/oilTestEngines/OilTestEnginesWrapper')
);
const UserRoute = React.lazy(() => import('./UserRoute'));

export const userRoutes = [
    {
        getComponent: () => <UserRoute />,
        path: ClientWrapperPages.USER,
        routes: [
            {
                getComponent: () => <Outlet />,
                path: ClientWrapperPages.DASHBOARD,
                routes: [
                    {
                        getComponent: () => <DashboardMyCompanyWrapper />,
                        path: ClientPages.MY_COMPANY,
                    },
                ],
            },
            {
                getComponent: () => <ProductWrapper />,
                path: ClientPages.PRODUCT,
                routes: [
                    {
                        getComponent: () => <ProductDetails />,
                        path: ClientPages.PRODUCT_NEW,
                    },
                    {
                        getComponent: () => <Outlet />,
                        path: ClientWrapperPages.PRODUCT_EDIT,
                        routes: [
                            {
                                getComponent: () => <ProductDetails />,
                                path: `:${Params.PRODUCT_ID}`,
                            },
                        ],
                    },
                    {
                        getComponent: () => <Outlet />,
                        path: ClientWrapperPages.PRODUCT_EDIT,
                        routes: [
                            {
                                getComponent: () => <Outlet />,
                                path: `:${Params.PRODUCT_ID}`,
                                routes: [
                                    {
                                        getComponent: () => <Outlet />,
                                        path: ClientPages.PRODUCT_FORMULATION_NEW,
                                        routes: [
                                            {
                                                getComponent: () => <FormulationWrapper />,
                                                path: ``,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                getComponent: () => <Outlet />,
                                path: `:${Params.PRODUCT_ID}`,
                                routes: [
                                    {
                                        getComponent: () => <Outlet />,
                                        path: ClientWrapperPages.PRODUCT_FORMULATION_EDIT,
                                        routes: [
                                            {
                                                getComponent: () => <FormulationWrapper />,
                                                path: `:${Params.FORMULATION_ID}`,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                getComponent: () => <Outlet />,
                                path: `:${Params.PRODUCT_ID}`,
                                routes: [
                                    {
                                        getComponent: () => <Outlet />,
                                        path: ClientWrapperPages.PRODUCT_APPROVAL_DETAILS,
                                        routes: [
                                            {
                                                getComponent: () => <ProductApprovalWrapper />,
                                                path: `:${Params.PRODUCT_APPROVAL_ID}`,
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                getComponent: () => <ServiceWrapper />,
                path: ClientPages.SERVICE,
            },
            {
                getComponent: () => <OilTestEnginesWrapper />,
                path: ClientPages.OILTESTENGINES,
            },
        ],
    },
];
